import { jsx as _jsx } from "react/jsx-runtime";
import CoreButton from '../Buttons/CoreButton';
import useSignOut from '@components/Hooks/useSignOut';
const LogoutButton = ({ className, children, ...coreButtonProps }) => {
    const { signOut } = useSignOut();
    return (_jsx(CoreButton, { className: className, type: "button", onClick: signOut, ...coreButtonProps, children: children }));
};
export default LogoutButton;
